module.exports = __webpack_public_path__ + "img/11.77c8e57a.jpg";